import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1dzbmjz3lp: FaireBrandEntity = {
  token: "b_1dzbmjz3lp",
  type: "brand",
  name: "Art by any Means Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/f290f3a707cd9dfc878f0068922124ea6b7a9cc535c092e9b10ea14c267536b2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/74ee2e0be99c3e2aa204c806e83fb8151397d27d99f049c36f9d0984cd2c530c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f290f3a707cd9dfc878f0068922124ea6b7a9cc535c092e9b10ea14c267536b2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/74ee2e0be99c3e2aa204c806e83fb8151397d27d99f049c36f9d0984cd2c530c.jpeg",
  location: "Rockport, MA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 37,
  isTopShop: true,
  isInsider: true,
  description:
    "Handmade in small batches in Vanessa Savlen’s sunlit Rockport, MA studio, Art by Any Means Jewelry (Est. 1999) features original, light-sculptural designs layered with hand-formed mixed metals and wrapped gemstones. Offer your customers earthy, glamorous, artisan-made jewelry that reflects your store's dedication to handmade quality.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:46.372Z",
    importedBy: "entity-db-cli",
  },
};
